var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 2.29289C7.68342 1.90237 8.31658 1.90237 8.70711 2.29289L12 5.58579L14.2929 3.29289C14.6834 2.90237 15.3166 2.90237 15.7071 3.29289C16.0976 3.68342 16.0976 4.31658 15.7071 4.70711L14.4142 6H21C22.6569 6 24 7.34315 24 9V17C24 18.6569 22.6569 20 21 20H20.4142L20.7071 20.2929C21.0976 20.6834 21.0976 21.3166 20.7071 21.7071C20.3166 22.0976 19.6834 22.0976 19.2929 21.7071L17.5858 20H6.41421L4.70711 21.7071C4.31658 22.0976 3.68342 22.0976 3.29289 21.7071C2.90237 21.3166 2.90237 20.6834 3.29289 20.2929L3.58579 20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6H9.58579L7.29289 3.70711C6.90237 3.31658 6.90237 2.68342 7.29289 2.29289ZM3 8C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H21C21.5523 18 22 17.5523 22 17V9C22 8.44772 21.5523 8 21 8H3Z",
    fill: "#293644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.c4d51a61d67038ae95c93ef57da26c09.svg";
export { ForwardRef as ReactComponent };